"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionalUserAmbientValue = exports.UserAmbientValue = void 0;
const AmbientValue_1 = require("./AmbientValue");
class UserAmbientValue extends AmbientValue_1.AmbientValue {
    constructor() {
        super(...arguments);
        this.name = "user";
    }
}
exports.UserAmbientValue = UserAmbientValue;
class OptionalUserAmbientValue extends AmbientValue_1.AmbientValue {
    constructor() {
        super(...arguments);
        this.name = "user?";
    }
}
exports.OptionalUserAmbientValue = OptionalUserAmbientValue;
//# sourceMappingURL=UserAmbientValue.js.map